// Free-tier allocations, mirrored from the backend's free-tier constants
// (identity's FREE_TIER_DEFAULTS and billing's free-tier quota maps). Keep the
// values in sync with the backend.
//
// In the credits world these constants apply ONLY to orgs whose settings
// explicitly opt into the legacy monthly allowance (freeTier: 'monthly' on the
// product block). The default ('credit', or the attribute unset) means an
// absent limit really is 0 -- free usage arrives as granted usage credits (the
// pushed *Credit settings values) instead of an implicit monthly allocation.
export const PEOPLE_RECORD_FREE_QUOTA = 500;
export const CHAT_SNAPSHOT_FREE_QUOTA = 15;
export const CHAT_DEEP_RESEARCH_FREE_QUOTA = 3;
export const CHAT_COST_FREE_QUOTA_CENTS = 2500;

// The base allowance an unset limit falls back to for a product block of org
// settings ('people' or 'chat'): the legacy monthly free-tier constant only
// when the block explicitly says freeTier === 'monthly', else 0.
export function freeTierBase(
  productSettings: { freeTier?: string } | null | undefined,
  monthlyDefault: number
): number {
  return productSettings?.freeTier === 'monthly' ? monthlyDefault : 0;
}
